import { PlusIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';
import { MulticheckStore } from '../Store';

interface Props<T> {
  store: MulticheckStore<T>;
}

function SelectAll<T>({ store }: Props<T>) {
  return (
    <div
      className="mr-1 h-5 w-5 flex items-center cursor-pointer bg-teal-600 text-white rounded-sm"
      onClick={store.selectAll}
    >
      <PlusIcon className="h-5 w-5" aria-hidden="true" />
    </div>
  );
}

export default observer(SelectAll);
